let About = window.__BH;

var hostOrgin=location.origin;//当前主机地址
var hostMap=About.ServerMap||{};//主机地址的匹配
var FISMap=Object.keys(hostMap).length>0;

// var printOrgin=About.PrintHtmlService.baseUrl;
	
if(FISMap){
	//修改打印地址
	if(hostMap[hostOrgin]&&hostMap[hostOrgin]['printUrl']&&hostMap[hostOrgin]['printUrl']!=''){
		let targetUrl=hostMap[hostOrgin]['printUrl'];
		targetUrl=targetUrl+'/';
		if(About['PrintHtmlService']&&About['PrintHtmlService']['baseUrl']){
			window.__BH['PrintHtmlService']['baseUrl']=targetUrl;
			About['PrintHtmlService']['baseUrl']=targetUrl;
		}
	}
}

export let AboutProject = About || {};
